import { render, staticRenderFns } from "./TrelloDashboard.vue?vue&type=template&id=2afad497&scoped=true&functional=true&"
import script from "./TrelloDashboard.vue?vue&type=script&lang=js&"
export * from "./TrelloDashboard.vue?vue&type=script&lang=js&"
import style0 from "./TrelloDashboard.vue?vue&type=style&index=0&id=2afad497&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "2afad497",
  null
  
)

export default component.exports